import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getUserInfo } from '../utils';

export default function AuthRoute() {
	const location = useLocation();
	const userInfo = getUserInfo();
	return userInfo ? <Outlet /> : <Navigate to='/signin' state={{ from: location }} replace />;
}
